import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ReactCountryFlag from "react-country-flag";
import { makeStyles } from "@mui/styles";

const RussianFlag = () => (
  <ReactCountryFlag
    countryCode="RU"
    svg
    style={{
      width: "4em",
      height: "4em",
    }}
  />
);
const EnglishFlag = () => (
  <ReactCountryFlag
    countryCode="GB"
    svg
    style={{
      width: "4em",
      height: "4em",
    }}
  />
);
const GreekFlag = () => (
  <ReactCountryFlag
    countryCode="GR"
    svg
    style={{
      width: "4em",
      height: "4em",
    }}
  />
);

const languages = [
  {
    code: "en",
    name: "EN",
  },
  {
    code: "ru",
    name: "RU",
  },
  {
    code: "el",
    name: "EL",
  },
];

const useStyles = makeStyles((theme: Theme) => ({
  flagContainer: {
    cursor: "pointer",
  },
}));

const SelectLanguage = () => {
  const classes = useStyles();
  const { i18n, t } = useTranslation();

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <Box display="flex" alignItems="center">
      <Box
        className={classes.flagContainer}
        onClick={() => changeLanguage("el")}
        mr={2}
      >
        <GreekFlag />
      </Box>
      <Box
        className={classes.flagContainer}
        onClick={() => changeLanguage("en")}
        mr={2}
      >
        <EnglishFlag />
      </Box>
      <Box
        className={classes.flagContainer}
        onClick={() => changeLanguage("ru")}
        mr={2}
      >
        <RussianFlag />
      </Box>
    </Box>
  );
};

export default SelectLanguage;
